import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.REACT_APP_SERVER_URL || 'http://localhost:8000/swipe_gol',
})


export function getLeaderboard() {
  return instance.get('/leaderboard/');
}